'use client';

import Image from 'next/image';
import { useRouter } from 'next/navigation';
import AppButton from './components/app-button';

export default function NotFound() {
  const router = useRouter();

  return (
    <div className="min-h-screen flex items-center justify-center bg-[color:var(--background)] text-[color:var(--text-primary)] px-6">
      <div className="text-center max-w-md">
        <Image
          src="/assets/logo-w.webp"
          alt="XOX logo"
          width={150}
          height={45}
          className="h-10 w-auto mx-auto mb-8"
          priority
        />
        <h1 className="text-[color:var(--text-muted)] mb-8">
          404 Page not found
        </h1>
        <div className="flex flex-col sm:flex-row gap-4 items-center justify-center">
          <AppButton
            text="To Homepage"
            variant="transparent"
            size="md"
            onClick={() => router.push('/')}
          />
        </div>
      </div>
    </div>
  );
}

